const types = {
	TEMPLATE_LIST_START: "TEMPLATE_LIST_START",
	TEMPLATE_LIST_SUCCESS: "TEMPLATE_LIST_SUCCESS",
	TEMPLATE_LIST_ERROR: "TEMPLATE_LIST_ERROR",

	CREATE_TEMPLATE_START: "CREATE_TEMPLATE_START",
	CREATE_TEMPLATE_SUCCESS: "CREATE_TEMPLATE_SUCCESS",
	CREATE_TEMPLATE_ERROR: "CREATE_TEMPLATE_ERROR",
	CREATE_TEMPLATE_STATE_RESET: "CREATE_TEMPLATE_STATE_RESET",

	UPDATE_TEMPLATE_START: "UPDATE_TEMPLATE_START",
	UPDATE_TEMPLATE_SUCCESS: "UPDATE_TEMPLATE_SUCCESS",
	UPDATE_TEMPLATE_ERROR: "UPDATE_TEMPLATE_ERROR",
	UPDATE_TEMPLATE_STATE_RESET: "UPDATE_TEMPLATE_STATE_RESET",

	DELETE_TEMPLATE_START: "DELETE_TEMPLATE_START",
	DELETE_TEMPLATE_SUCCESS: "DELETE_TEMPLATE_SUCCESS",
	DELETE_TEMPLATE_ERROR: "DELETE_TEMPLATE_ERROR",
	DELETE_TEMPLATE_STATE_RESET: "DELETE_TEMPLATE_STATE_RESET",

	TEMPLATE_DETAILS_START: "TEMPLATE_DETAILS_START",
	TEMPLATE_DETAILS_SUCCESS: "TEMPLATE_DETAILS_SUCCESS",
	TEMPLATE_DETAILS_ERROR: "TEMPLATE_DETAILS_ERROR",

	SEND_MAIL_WITH_PDF_START: "SEND_MAIL_WITH_PDF_START",
	SEND_MAIL_WITH_PDF_SUCCESS: "SEND_MAIL_WITH_PDF_SUCCESS",
	SEND_MAIL_WITH_PDF_ERROR: "SEND_MAIL_WITH_PDF_ERROR",

	CLEAR_TEMPLATE_DETAILS: "CLEAR_TEMPLATE_DETAILS",

	DUPLICATE_TEMPLATE_START: "DUPLICATE_TEMPLATE_START",
	DUPLICATE_TEMPLATE_SUCCESS: "DUPLICATE_TEMPLATE_SUCCESS",
	DUPLICATE_TEMPLATE_ERROR: "DUPLICATE_TEMPLATE_ERROR",
};
export default types;